import React, { useState } from "react";
import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";

const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  align-items: center;
  padding-right: 8px;
`;

const CloseBtn = styled.div`
  margin-right: auto;
  color: black;
  cursor: pointer;
`;

const FlexRow = styled.div`
  display: flex;
  gap: 8px;
`;

const ReadonlyTextField = styled(TextField)`
  & input {
    color: black;
    direction: ltr;
  }
  background-color: white;
  border-radius: 4px;
`;

const CopyButton = styled.div`
  background-color: white;
  cursor: pointer;
  color: black;
  display: flex;
  align-items: center;
`;

const AlertMsg = styled(Alert)`
  display: flex;
  flex-direction: row-reverse;
`;

export function ShareModal({ open, onClose, url, label = "Link" }) {
  const [copiedMsg, setCopiedMsg] = useState("");

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedMsg("הועתק");
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        setCopiedMsg("הועתק");
      } finally {
        document.body.removeChild(ta);
      }
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: 2, bgcolor: "white", color: "black" },
        }}
      >
        <StyledDialogTitle>
          לינק שיתוף
          <CloseBtn aria-label="close" onClick={onClose} size="small">
            <CloseIcon />
          </CloseBtn>
        </StyledDialogTitle>

        <DialogContent sx={{ pt: 1, pb: 2 }}>
          <FlexRow>
            <ReadonlyTextField
              value={url}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
              variant="outlined"
            />
            <CopyButton
              aria-label={`copy ${label}`}
              onClick={() => copyToClipboard(url)}
              size="small"
            >
              <ContentCopyIcon fontSize="small" />
            </CopyButton>
          </FlexRow>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={!!copiedMsg}
        autoHideDuration={1800}
        onClose={() => setCopiedMsg(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <AlertMsg severity="success" sx={{ width: "100%" }}>
          {copiedMsg}
        </AlertMsg>
      </Snackbar>
    </>
  );
}
